var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoadOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.332 14.483a1.333 1.333 0 001.333 0l4.665-2.666a1.333 1.333 0 00.667-1.153V5.332a1.334 1.334 0 00-.667-1.153L8.665 1.513a1.333 1.333 0 00-1.333 0L2.666 4.179A1.333 1.333 0 002 5.332v5.332a1.333 1.333 0 00.666 1.153l4.666 2.666zM7.998 14.663V7.998",
    stroke: "#2355FC",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.193 4.666l5.805 3.332 5.805-3.332M4.999 2.846l5.998 3.432",
    stroke: "#2355FC",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgLoadOutlined;